export default __webpack_public_path__ + "static/media/Titulo.f4ed18d6.png";